import { Modal as AntModal } from 'antd';

import './index.scss';

export const Modal = ({ className = '', children, ...rest }) => (
	<AntModal className={`spa__modal ${className}`} {...rest} closeIcon={<i className="icon-remove" />}>
		{children}
	</AntModal>
);
